<template>
    <div class="crm-main-cont">
        <div class="search-box">
            <a-table
                    :rowKey="'id'"
                    bordered
                    :dataSource="orderList"
                    :pagination="pagination"
                    @change="change"
                    :columns="columns"
            >
                <template slot-scope="text,record" slot="operation">
                    <a @click="showDetails(record)">查看订单</a>
                </template>
            </a-table>
        </div>

        <a-drawer
                title="订单详情"
                :width="750"
                @close="onClose"
                :visible="orderVisible"
        >
            <a-descriptions title="订单信息" :column="2" bordered class="order-table">
                <a-descriptions-item>
                    <a-descriptions title="主体信息" :column="2" bordered>
                        <a-descriptions-item label="主体名称">
                            {{ orderData.companyName }}
                        </a-descriptions-item>
                        <a-descriptions-item label="统一社会信用代码">
                            {{ orderData.socialCreditUnicode }}
                        </a-descriptions-item>
                        <a-descriptions-item label="法定代表人" v-if="orderData.zttype===2">
                            {{ orderData.frdb }}
                        </a-descriptions-item>
                        <a-descriptions-item :label="orderData.zttype===2?'经营地址':'联系地址'">
                            {{ orderData.address }}
                        </a-descriptions-item>
                    </a-descriptions>
                    <a-descriptions title="融资信息" :column="2" bordered class="labelCls">
                        <a-descriptions-item label="申请产品">
                            {{ orderData.productName }}
                        </a-descriptions-item>
                        <a-descriptions-item label="申贷金额">
                            {{orderData.commitAmout==undefined?0:
                            String(orderData.commitAmout).replace(
                            /\B(?=(\d{3})+(?!\d))/g,
                            ","
                            )
                            }}元
                        </a-descriptions-item>
                        <a-descriptions-item label="申请日期">
                            {{ orderData.createTime }}
                        </a-descriptions-item>
                        <a-descriptions-item label="经办人">
                            {{ orderData.contact }}
                        </a-descriptions-item>
                        <a-descriptions-item label="经办人身份证号码">
                            {{ orderData.contactIdcard }}
                        </a-descriptions-item>
                        <a-descriptions-item label="经办人手机号码">
                            {{ orderData.contactMobile }}
                        </a-descriptions-item>
                    </a-descriptions>
                    <a-descriptions title="授信信息" :column="2" bordered class="labelCls">
                        <a-descriptions-item label="授信金额">
                            <span v-if="orderData.loanAmout != null">{{
                                  String(orderData.loanAmout).replace(
                                      /\B(?=(\d{3})+(?!\d))/g,
                                      ","
                                  )
                                  }}元
                            </span>
                            <span v-if="orderData.loanAmout == null">-</span>
                        </a-descriptions-item>
                        <a-descriptions-item label="授信利率">
                            <span v-if="orderData.interestRate != null">{{Number(orderData.interestRate).toFixed(4)}}%</span>
                            <span v-if="orderData.interestRate == null">-</span>
                        </a-descriptions-item>
                        <a-descriptions-item label="授信日期">
                            <span v-if="orderData.loanTime != null">{{orderData.loanTime}}</span>
                            <span v-if="orderData.loanTime == null">-</span>
                        </a-descriptions-item>
                        <a-descriptions-item label="授信期限">
                            <span v-if="orderData.deadline != null">{{orderData.deadline}}个月</span>
                            <span v-if="orderData.deadline == null">-</span>
                        </a-descriptions-item>
                    </a-descriptions>
                    <a-descriptions title="受理机构信息" :column="2" bordered v-if="orderData.yxdwUserId!=null"
                                    class="labelCls">
                        <a-descriptions-item label="受理人">
                            {{account.name}}
                        </a-descriptions-item>
                        <a-descriptions-item label="受理人手机">
                            {{account.mobile}}
                        </a-descriptions-item>
                        <a-descriptions-item label="受理机构">
                            {{account.department}}{{account.nickName}}
                        </a-descriptions-item>

                    </a-descriptions>
                </a-descriptions-item>
            </a-descriptions>
            <a-descriptions style="margin-top: 20px" title="放款信息" :column="2" bordered>
                <a-descriptions-item label="放款金额">
                    {{ loanData.loanAmount==undefined?0:loanData.loanAmount }}元
                </a-descriptions-item>
                <a-descriptions-item label="放款利率">
                    {{ loanData.lendingRate==undefined?0.00:loanData.lendingRate }}%
                </a-descriptions-item>
                <a-descriptions-item label="放款期限">
                    {{ loanData.loanPeriod==undefined?0:loanData.loanPeriod }}个月
                </a-descriptions-item>
                <a-descriptions-item label="放款日期">
                    {{ loanData.loanDate }}
                </a-descriptions-item>
                <a-descriptions-item label="创建时间">
                    {{ loanData.createTime }}
                </a-descriptions-item>
                <a-descriptions-item label="担保机构">
                    {{ loanData.guaranteeId }}
                </a-descriptions-item>
            </a-descriptions>
        </a-drawer>

    </div>
</template>

<script>
import {
    getGuaranteeOrder,
    findById,
} from "@/api/finance/guaranteeOrder"

import {
    getAllGuarantee
} from "@/api/http"
import {getAccount} from "@/api/yhgl/account";
import moment from 'moment';

const columns = [
    {
        title: '放款金额（元）',
        dataIndex: 'loanAmount',
        key: "loanAmount",
    },
    {
        title: '放款利率（%）',
        dataIndex: 'lendingRate',
        key: "lendingRate",
    },
    {
        title: '放款期限（月）',
        dataIndex: 'loanPeriod',
        key: "loanPeriod",
    },
    {
        title: '放款日期',
        dataIndex: 'loanDate',
        key: "loanDate",
        customRender: (val, row, index) => {
            return val ? moment(val).format('YYYY-MM-DD') : ''
        },
    },
    {
        title: '创建时间',
        dataIndex: 'createTime',
        key: "createTime",
        customRender: (val, row, index) => {
            return val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : ''
        },
    },
    {
        title: '操作',
        dataIndex: 'operation',
        key: "operation",
        scopedSlots: {customRender: "operation"}
    },
];

export default {
    name: "guaranteeOrder",
    computed: {},
    data() {
        return {
            value: "",
            columns,
            orderVisible: false,
            guaranteeList: [],
            orderList: [],
            orderData: {},
            account: {},
            loanData: {},
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0
            },
        }
    },
    beforeRouteEnter(to, form, next) {
        next(vm => {
            vm.init();
            vm.getAllGuarantee();
        })
    },
    methods: {
        init() {
            //初始化
            getGuaranteeOrder(this.pagination.current, this.pagination.pageSize).then(res => {
                if (res.data.success == "TRUE") {
                    this.orderList = res.data.data.page.list;
                    Object.assign(this.pagination, {
                        current: res.data.data.page.pageNum,
                        pageSize: res.data.data.page.pageSize,
                        total: res.data.data.page.total
                    });
                }
            })
        },
        change(page) {
            this.pagination = page;
            this.init();
        },
        onClose() {
            this.orderVisible = false;
            this.account = {};
            this.orderData = {};
            this.loanData = {};
        },
        showDetails(data) {
            this.orderVisible = true;
            this.$nextTick(() => {
                Object.assign(this.loanData, data, {
                    guaranteeId: this.guaranteeList.find(res => res.id == data.guaranteeId).full_name,
                    loanDate: moment(data.loanDate).format("YYYY-MM-DD"),
                    createTime: moment(data.createTime).format("YYYY-MM-DD HH:mm:ss")
                })
                this.getOrderDetails(data.companyId);
                console.log(111)
            })
        },
        async getOrderDetails(id) {
            let data = new FormData();
            data.append("id", id);
            await findById(data).then(res => {
                if (res.data.success == "TRUE") {
                    this.orderData = res.data.data.page.list[0];
                    //创建日期
                    this.orderData.createTime = moment(this.orderData.createTime).format("YYYY-MM-DD HH:mm:ss");
                    //授信日期
                    this.orderData.loanTime = moment(this.orderData.loanTime).format("YYYY-MM-DD HH:mm:ss");
                    if (res.data.data.page.list[0].yxdwUserId) {
                        getAccount(res.data.data.page.list[0].yxdwUserId).then(res => {
                            if (res.data.success === "TRUE") {
                                this.account = res.data.data.account;
                                console.log(this.account)
                            }
                        })
                    }
                }
            }).catch(() => this.$message.error("服务器异常，请稍后再试！"))
        },
        getAllGuarantee() {
            getAllGuarantee().then(res => {
                if (res.data.success == "TRUE") {
                    this.guaranteeList = res.data.data.list;
                }
            }).catch(() => this.$message.error("服务器异常，请稍后再试！"))
        },
    }
}
</script>

<style scoped>
    /deep/ .order-table > .ant-descriptions-view {
        border: none;
    }

    /deep/ .order-table th.ant-descriptions-item-label.ant-descriptions-item-colon.ant-descriptions-item-no-label {
        display: none;
    }

    .labelCls {
        margin-top: 20px;
    }
</style>
